<ul class="activities">
  @for (activity of items(); track activity.id) {
    @if (activity.state === STATE_PUBLISHED || showUnpublished()) {
      <li>
        <app-activity-preview
          [item]="activity"
          [isPublic]="isPublic()"
          [showHost]="showHost()"
          [showState]="showState()"
          [showDistance]="showDistance()">
        </app-activity-preview>
      </li>
    }
  }
</ul>
